// src/data/emailWorkflowData.js
//
// Landing-page email workflow example. Taken from the docket next-steps output
// the agent produced for KalshiEX LLC v. Knudsen, No. 6:26-cv-00028 (D. Mont.)
// - the same matter and the same top action item as the "docket" conference
// demo fixture in Lambda_intentHandler.py. Keep the two in sync so the lander
// and the live demo tell one story.
export const emailWorkflowData = {
    EMAIL: "To: vienna@nougat.law",
    SUBJECT: "Next steps - KalshiEX LLC v. Knudsen",
    BODY: `Plaintiff just filed an objection to the magistrate judge's order and our joint status update is due August 21.\nTell me what needs to go on file and draft it.`,
    DOC_TITLE: "Draft Ready - Joint Status Report (D. Mont. 6:26-cv-00028)",
    DOC_FILE: "Joint_Status_Report_v1.docx",
    DOC_TEXT: `Joint Status Report

Pursuant to the Court's order staying these proceedings for sixty days, the parties
respectfully submit this joint status report.

1. Progress during the stay.
The parties have conferred on the disputed requests for production that were the
subject of the magistrate judge's June 22 order and have narrowed, but not resolved,
the issues raised in Plaintiff's objection filed August 18.

2. Whether discussions have resolved the issues.
The parties have reached agreement on the scope of custodial search terms. The
parties have not reached agreement on the privilege log format or on the timing of
the supplemental production.

3. Relief and scheduling requested.
The parties jointly request that the Court set a briefing schedule on Plaintiff's
pending objection and reset the pretrial motion response and reply deadlines that
were suspended by the stay.

--------------------------------------------------------------------

Why this filing, and what it depends on:

1. Draft joint status update for August 21 - Extremely High, est. 1h 30m.
   Address progress during the court-ordered sixty-day stay, whether discussions
   resolved the issues, and the relief or scheduling the parties request. Circulate
   to opposing counsel for factual confirmation before filing.

2. Map deadlines following the stay - High, est. 1h.
   Extract the stayed obligations and every deadline that must be reinstated,
   extended, or proposed in the status update, then produce a post-stay deadline
   chart naming the responsible party and the required filing or response.

3. Resolve position on extending the stay - High, est. 1h.
   Decide whether to authorize an agreed extension, request further relief, or file
   the status update as is. Record the position and the exact period requested.

Related deadline, computed from the local rule rather than a date field:
Reply in support of the Motion to Continue Pretrial Motion Response and Reply
Deadlines was due July 20, 2026 - seven days after the timely opposition, per
D. Mont. L.R. 7.1(d)(1). No order extends or modifies that briefing schedule.`,
};
